import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { useI18n } from '../i18n/I18nProvider';
import { I18nProvider } from '../i18n/I18nProvider';
import { DEFAULT_LOCALE } from '../i18n/config';
import { LEANPUB_URL } from '../lib/constants';
import { getAllBlogPosts } from '../lib/blogPosts';
import { Calendar, Clock } from 'lucide-react';

const Blog = () => {
  return (
    <I18nProvider initialLocale={DEFAULT_LOCALE}>
      <BlogContent />
    </I18nProvider>
  );
};

const BlogContent = () => {
  const { t } = useI18n();
  const posts = getAllBlogPosts();

  return (
    <>
      <Helmet>
        <title>Blog - Angular Testing | Guías y Tutoriales sobre Testing en Angular</title>
        <meta name='description' content='Artículos técnicos sobre testing en Angular, Jest, Testing Library y mejores prácticas para desarrolladores.' />
        <meta property='og:title' content='Blog - Angular Testing' />
        <meta property='og:description' content='Artículos técnicos sobre testing en Angular, Jest y Testing Library' />
        <meta property='og:type' content='website' />
        <html lang='es' />
        <link rel='canonical' href='/blog' />
      </Helmet>

      <div className='min-h-screen flex flex-col'>
        <Header leanpubUrl={LEANPUB_URL} />
        <main className='flex-grow pt-16'>
          <div className='container mx-auto px-4 sm:px-6 lg:px-8 py-12'>
            <div className='max-w-4xl mx-auto'>
              <h1 className='text-4xl font-bold mb-4'>Blog</h1>
              <p className='text-xl text-gray-600 mb-12'>
                Artículos técnicos sobre testing en Angular, Jest, Testing Library y mejores prácticas
              </p>

              <div className='space-y-8'>
                {posts.map((post) => (
                  <article
                    key={post.id}
                    className='bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow p-6 md:p-8'
                  >
                    <div className='flex items-center gap-4 text-sm text-gray-500 mb-4'>
                      <div className='flex items-center gap-1'>
                        <Calendar className='h-4 w-4' />
                        <time dateTime={post.date}>
                          {new Date(post.date).toLocaleDateString('es-ES', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                          })}
                        </time>
                      </div>
                      <div className='flex items-center gap-1'>
                        <Clock className='h-4 w-4' />
                        <span>{post.readTime}</span>
                      </div>
                    </div>

                    <h2 className='text-2xl font-bold mb-3'>
                      <Link
                        to={`/blog/${post.slug}`}
                        className='text-gray-900 hover:text-primary transition-colors'
                      >
                        {post.title}
                      </Link>
                    </h2>

                    <p className='text-gray-600 mb-4 leading-relaxed'>{post.description}</p>

                    <div className='flex flex-wrap gap-2 mb-4'>
                      {post.keywords.slice(0, 3).map((keyword) => (
                        <span
                          key={keyword}
                          className='px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full'
                        >
                          {keyword}
                        </span>
                      ))}
                    </div>

                    <Link
                      to={`/blog/${post.slug}`}
                      className='inline-flex items-center text-primary hover:text-primary/80 font-medium transition-colors'
                    >
                      Leer más →
                    </Link>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Blog;
